import { render, staticRenderFns } from "./AdesManagement.vue?vue&type=template&id=fb64b784&scoped=true&"
import script from "./AdesManagement.vue?vue&type=script&lang=js&"
export * from "./AdesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb64b784",
  null
  
)

export default component.exports